import { IfcComponent } from '../../../base-types';
export class IfcSelection extends IfcComponent {
    constructor(context, loader, material) {
        super(context);
        this.context = context;
        this.mesh = null;
        this.pick = async (item, focusSelection = false) => {
            if (this.selected === item.faceIndex || item.faceIndex == null)
                return null;
            this.selected = item.faceIndex;
            const mesh = item.object;
            const id = await this.loader.ifcManager.getExpressId(mesh.geometry, item.faceIndex);
            if (id === undefined)
                return null;
            this.hideSelection(mesh);
            this.modelID = mesh.modelID;
            this.newSelection([id]);
            if (focusSelection)
                this.focusSelection();
            return { modelID: this.modelID, id };
        };
        this.pickByID = async (modelID, ids, focusSelection = false) => {
            this.modelID = modelID;
            this.newSelection(ids);
            if (focusSelection)
                await this.focusSelection();
        };
        this.newSelection = (ids) => {
            const mesh = this.loader.ifcManager.createSubset({
                scene: this.scene,
                modelID: this.modelID,
                ids,
                removePrevious: true,
                material: this.material
            });
            if (mesh) {
                this.mesh = mesh;
                this.mesh.visible = true;
            }
        };
        this.scene = context.getScene();
        this.loader = loader;
        if (material)
            this.material = material;
        this.selected = -1;
        this.modelID = -1;
    }
    dispose() {
        var _a, _b, _c;
        (_a = this.mesh) === null || _a === void 0 ? void 0 : _a.removeFromParent();
        (_b = this.mesh) === null || _b === void 0 ? void 0 : _b.geometry.dispose();
        (_c = this.material) === null || _c === void 0 ? void 0 : _c.dispose();
        this.mesh = null;
        this.material = null;
        this.scene = null;
        this.loader = null;
        this.context = null;
    }
    unpick() {
        this.mesh = null;
        this.loader.ifcManager.removeSubset(this.modelID, this.material);
    }
    hideSelection(mesh) {
        if (this.mesh && this.modelID !== undefined && this.modelID !== (mesh === null || mesh === void 0 ? void 0 : mesh.modelID)) {
            this.mesh.visible = false;
        }
    }
    async focusSelection() {
        if (this.mesh) {
            await this.context.ifcCamera.targetItem(this.mesh);
        }
    }
}
//# sourceMappingURL=selection.js.map